export default {
    noData: 'No data found'
}
